<template>
  <div id="app" :class="[isPC && 'pc', {en: globalLang === 'en'}]" :style="minWidth">
    <!-- header 动态组件 -->
    <component v-if="showingHeader && !mobDevice" :is="header"></component>
    <component v-if="mobDevice && showingH5Header" :is="header"></component>
    <transition name="router" mode="out-in">
      <router-view />
    </transition>
    <!-- footer 动态组件 -->
    <component v-if="showingFooter" :is="footer"></component>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import headerPc from "@commonHeader/pc";
import headerH5 from "@commonHeader/h5";
import footerPc from "@commonFooter/pc/index";
import footerH5 from "@commonFooter/h5/index";
import { isMobile, isTablet } from "./utils/device";

import Vue from 'vue'
Vue.mixin({
  computed: {
    ...mapGetters(["globalLang"]),
  },
  methods: {
    getResCode(resCode) {
      return this.$t(`error.${resCode}`)
    }
  }
})


export default {
  components: {
    headerPc,
    headerH5,
    footerPc,
    footerH5
  },
  computed: {
    ...mapGetters(["showingHeader", "showingFooter", "showingH5Header", "globalLang"]),
    isPC () {
      return !isMobile() && !isTablet();
    },
    mobDevice() {
        return (isMobile() || isTablet()) && (this.$route.name !== 'home');
    },
    header() {
      return "header-" + (this.mobDevice ? "h5" : "pc");
    },
    footer() {
      return "footer-" + (this.mobDevice ? "h5" : "pc");
    },
    minWidth() {
      return {
        minWidth: this.mobDevice ? "" : "1300px"
      };
    }
  },
  methods: {
    ...mapActions({
      setLang: 'setGlobalLang'
    })
  },
  created() {
    this.setLang()
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Arial", "SourceHanSansSC-Regular", "Avenir", Helvetica, sans-serif, "MicrosoftYaHei";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  -webkit-overflow-scrolling: touch;
  &.pc {
    min-width: 1200px;
  }
  &.en {
    font-family: "Noto Sans SC", "Avenir", Helvetica, Arial, sans-serif;
  }
}

.router-enter-active,
.router-leave-active {
  transition: opacity 0.2s;
}

.router-enter,
.router-leave-to {
  opacity: 0;
}


html,
body {
  width: 100%;
  // height: 100%;
  // min-width: 1300px;
  max-width: 1920px;
  margin: 0 auto;
}
a {
  cursor: pointer;
}
</style>
